export const customLinkName = 'Custom link';

export const FORCE_SSO_LOGIN_KEY = 'force_sso_login';
